import { render, staticRenderFns } from "./ClientManagement.vue?vue&type=template&id=42318150&scoped=true"
import script from "./ClientManagement.vue?vue&type=script&lang=js"
export * from "./ClientManagement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42318150",
  null
  
)

export default component.exports